module["exports"] = [
  "#{prefix} #{first_name} #{last_name}",
  "#{first_name} #{last_name} #{suffix}",
  "#{first_name} #{last_name}",
  "#{first_name} #{last_name}",
  "#{first_name} #{last_name}",
  "#{first_name} #{last_name}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en/name/name.js
 ** module id = 332
 ** module chunks = 0
 **/